module.exports = __webpack_public_path__ + "static/media/BannerFigma.85ff468d.png";